import { useNavigate } from 'react-router-dom';
import SearchBox from '@/components/base/SearchBox';

export default function HeroSection() {
  const navigate = useNavigate();

  const handleSearch = (query: string) => {
    navigate(`/category/sousuo?q=${encodeURIComponent(query)}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="relative w-full pt-24 pb-14 md:pt-32 md:pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-primary-100/40 via-background-50 to-background-50"></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-accent-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-primary-100/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-6">
          <i className="ri-sparkling-line"></i>
          <span>已收录 50+ 优质网站，持续更新中</span>
        </div>

        <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
          一站式网址导航
          <span className="block text-primary-500">让上网更简单</span>
        </h1>
        <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚海量优质网址、热门工具与实用资源，无论办公、娱乐还是学习，
          告别繁琐搜索，一键直达目标网站
        </p>

        <SearchBox onSearch={handleSearch} />

        <div className="mt-10 flex items-center justify-center gap-8">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-foreground-900">12</div>
            <div className="text-xs text-foreground-500 mt-1">分类</div>
          </div>
          <div className="w-px h-10 bg-background-200"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-primary-500">50+</div>
            <div className="text-xs text-foreground-500 mt-1">收录网站</div>
          </div>
          <div className="w-px h-10 bg-background-200"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-500">10万+</div>
            <div className="text-xs text-foreground-500 mt-1">月访问量</div>
          </div>
        </div>
      </div>
    </section>
  );
}